module.exports = __webpack_public_path__ + "static/media/timer-effect-02.4a9d62b6.png";